import { render, staticRenderFns } from "./addClientCalendar.vue?vue&type=template&id=01f2a9e3&scoped=true&"
import script from "./addClientCalendar.vue?vue&type=script&lang=js&"
export * from "./addClientCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2a9e3",
  null
  
)

export default component.exports